import '@/plugins/vue-composition-api'
import '@/plugins/acl'
import '@/styles/global.css'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import router from './router'
import store from './store'
import '@/plugins/vuetify-mask'
import './plugins/vuetify-money.js'
import VuetifyMask from 'vuetify-mask'
import WOW from 'wowjs'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import 'animate.css'

Vue.use(Toast, {
  position: 'bottom-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false,
  transition: 'Vue-Toastification__bounce',
  maxToasts: 20,
  newestOnTop: true,
})

Vue.use(VuetifyMask)
new WOW.WOW().init()
Vue.use(VueSweetalert2)
Vue.config.productionTip = false

new Vue(({
  router,
  store,
  vuetify,
  render: h => h(App),
} as any)).$mount('#app')
